/* eslint-disable no-empty */
const $ = require("jquery");
const _ = require("underscore");
const Backbone = require("backbone");
const Mustache = require("mustache");
const events = require("common/event-aggregator");
const moment = require("moment");
const config = require("common/page-config");

const WeekdaySelectionView = Backbone.View.extend({
  events: {
    "click .next": "goNextWeek",
    "click .previous": "goPrevWeek",
    "click .js-day": "onDayClicked"
  },

  ui: {},

  selectedEmployee: null,
  pagination: {
    isNextRequestPending: false,
    isPreviousRequestPending: false,
    isAbleToPaginatiateBack: false
  },

  initialize (options) {
    this.options = options;
    this.collection = this.options.collection;

    // listen to employee change event
    this.listenTo(
      events,
      events.CHECKOUT_AVAILABILITY_EMPLOYEE_SELECTED,
      this.onEmployeeChanged
    );

    this.listenTo(
      events,
      events.CHECKOUT_AVAILABILITY_PAGINATE_LOAD,
      this.onPaginate
    );

    const dateLabel = this.options.initialDate ? "date" : "";
    const timeLabel = this.options.initialTime ? "time" : "";
    // one of "none", "date", "time", or "datetime"
    const trackingLabel =
      dateLabel || timeLabel ? `${dateLabel}${timeLabel}` : "none";

    // track initially selected date
    this.baseTrackingDate = this.options.initialDate
      ? moment(this.options.initialDate)
      : moment().startOf("day");
    const selectedDate = moment(this.collection.selectedDate);
    const diff = selectedDate.diff(this.baseTrackingDate);
    const relativeDate = moment.duration(diff).asDays();
    this.options.track.initial(trackingLabel, relativeDate);

    try {
      const priceRange = this.priceRangeData(this.collection.selectedDate);
      this.options.track.priceRange(
        "initial_select",
        priceRange.minPrice,
        priceRange.maxPrice,
        priceRange.minPriceSlotsAmount,
        priceRange.slotsAmount,
        priceRange.hasDiscount,
        relativeDate
      );
    } catch (e) {}

    // Keep track of whether the user lands on a date/time that has a
    // moreDaysInThePast: false on first load. This is because as they
    // paginate forward in time the API will give moreDaysInThePast: true
    // which would mean the arrow for previous would be incorrectly shown
    this.pagination.isAbleToPaginatiateBack =
      this.isFirstWeekDisplayed() && this.options.moreDaysInThePast;
  },

  setData ({
    firstIncludedDate,
    lastIncludedDate,
    moreDaysInTheFuture,
    moreDaysInThePast,
    direction
  }) {
    this.options.moreDaysInTheFuture = moreDaysInTheFuture;
    this.options.moreDaysInThePast = moreDaysInThePast;
    if (firstIncludedDate) {
      this.options.firstIncludedDate = firstIncludedDate;
    }
    if (firstIncludedDate && direction === "previous") {
      this.collection.setSelectedDate(firstIncludedDate);
    }
    if (lastIncludedDate) {
      this.options.lastIncludedDate = lastIncludedDate;
    }
    // After paginating ensure the employee data is accurate
    // as the user can paginate with anyone selected
    this.collection.updateEmployeeDays(this.selectedEmployee);
    this.render();
  },

  render () {
    // set the page"s nodes
    this.ui = {
      prev: this.$el.find(".previous"),
      next: this.$el.find(".next"),
      dateName: this.$el.find(".js-date-name"),
      dayList: this.$el.find(".js-day-list"),
      dayView: this.$el.find(".day-viewing-message")
    };

    // render month
    this.renderMonth();
    // render days
    this.renderDays();
    this.renderDateViewing();
    // toggle week navigation arrows
    this.toggleWeekArrows();
    // check initial selected week and reposition days
    if (this.collection.selectedWeek > 0) {
      setTimeout(
        _.bind(function () {
          this.repositionDays();
        }, this),
        0
      );
    }
  },

  renderMonth () {
    this.ui.dateName.text(this.getMonthLabel());
  },

  renderDateViewing () {
    var date = moment(this.collection.selectedDate).startOf("day");
    var dayOrdinal = date.format("Do");
    var dayOfTheWeek = date.format("dddd");
    var label = config.cms.common.labels["day-viewing-label"]
      .replace("{0}", dayOfTheWeek)
      .replace("{1}", dayOrdinal);
    this.ui.dayView.text(label);
  },

  getMonthLabel () {
    var unit, diff;
    var date = moment(this.collection.selectedDate).startOf("day");
    var now = moment().startOf("day");
    var text = date.format("MMMM YYYY");

    if (date.isSame(now, "isoWeek")) {
      // Current week is shown. No date distance text requried.
      return text;
    }

    // Set both dates to monday.
    date.isoWeekday(1);
    now.isoWeekday(1);

    unit = "week";
    diff = date.diff(now, unit);

    if (diff > 4) {
      unit = "month";
      diff = date.diff(now, unit);
    }

    text = text + ", ";

    if (diff === 1) {
      return text + config.cms.common.labels["next-" + unit];
    }

    return (
      text +
      config.cms.common.labels["in-months"]
        .replace("{{diff}}", diff)
        .replace("{{unit}}", config.cms.common.labels[unit + "s"])
    );
  },

  renderDays () {
    var template = $("#booking-mobile-datetime-days").html();

    this.ui.dayList.html(Mustache.render(template, this.collection.toJSON()));

    const selectedDate = moment(this.collection.selectedDate);
    const selectedDateNode = this.getDayElement(selectedDate);

    if (selectedDateNode.length) {
      this.onDaySelected({ currentTarget: selectedDateNode });
    }
  },

  onEmployeeChanged (data) {
    var employeeData = data.length === 0 ? null : data.toJSON();

    if (_.isEqual(this.selectedEmployee, employeeData)) {
      return;
    }

    // track selected employee so it can be dispatched in an event later
    this.selectedEmployee = employeeData;

    // update collection models with employee availability
    this.collection.updateEmployeeDays(employeeData);

    // re-render week days
    this.renderDays();
  },

  priceRangeData (date) {
    const selectedDay = this.collection.models.find((day) => day.date === date);

    const selectedDaySlotsData = this.getDaySlots(selectedDay.startTimes);
    const salePrices = selectedDaySlotsData.map(
      (slot) => slot.salePrice.amount
    );

    const minPrice = Math.min(...salePrices);
    const maxPrice = Math.max(...salePrices);
    const minPriceSlotsAmount = salePrices.filter((price) => price === minPrice)
      .length;

    const hasDiscount = selectedDaySlotsData
      .map((slot) => slot.discountType)
      .some((discount) => discount !== undefined);

    return {
      minPrice,
      maxPrice,
      minPriceSlotsAmount,
      slotsAmount: selectedDaySlotsData.length,
      hasDiscount
    };
  },

  onDayClicked (event) {
    const dayNode = $(event.currentTarget);
    const date = moment(dayNode.data("date"));
    const plainDate = dayNode.data("date");
    const diff = date.diff(this.baseTrackingDate);
    const relativeDate = moment.duration(diff).asDays();

    try {
      const priceRange = this.priceRangeData(plainDate);
      this.options.track.priceRange(
        "select",
        priceRange.minPrice,
        priceRange.maxPrice,
        priceRange.minPriceSlotsAmount,
        priceRange.slotsAmount,
        priceRange.hasDiscount,
        relativeDate
      );
      this.options.track.select(relativeDate);
    } catch (e) {}
    this.onDaySelected(event);
  },

  onDaySelected (event) {
    var dayNode = $(event.currentTarget);
    var date = dayNode.data("date");
    // update selected date
    this.selectDate(date);
  },

  /**
   * [selectDate description]
   * @param  {Object} date Moment object
   * @return {void}
   */
  selectDate (date) {
    const dayNode = this.ui.dayList.find(".js-day[data-date='" + date + "']");
    const dayModel = this.collection.getDayModelByDate(date);

    if (dayModel.get("available")) {
      $(".day-viewing-message").removeClass("day-viewing-message-hide");
    } else {
      $(".day-viewing-message").addClass("day-viewing-message-hide");
    }

    this.collection.setSelectedDate(date);
    this.renderMonth();
    this.renderDateViewing();

    dayNode.addClass("on").siblings().removeClass("on");

    // fire event checkout-availability:DaySelected with day collection"s model
    events.trigger(events.CHECKOUT_AVAILABILITY_DAY_SELECTED, {
      day: dayModel,
      employee: this.selectedEmployee
    });
  },

  goNextWeek () {
    this.options.track.forwards();
    const moreDaysInTheFuture = this.options.moreDaysInTheFuture;
    const oneWeekFromLast = this.collection.maxWeeks - 1;
    const twoWeekFromLast = this.collection.maxWeeks - 2;
    const selectedWeek = this.collection.selectedWeek;

    const canPaginate =
      (selectedWeek >= twoWeekFromLast || selectedWeek === oneWeekFromLast) &&
      moreDaysInTheFuture &&
      !this.pagination.isNextRequestPending;

    if (canPaginate) {
      this.dispatchNextPaginateEvent();
    }

    this.changeWeek(1);
  },

  goPrevWeek () {
    this.options.track.backwards();
    if (this.isFirstWeekDisplayed() && this.options.moreDaysInThePast) {
      this.dispatchPreviousPaginateEvent();
    }
    this.changeWeek(-1);
  },

  changeWeek (delta) {
    var newDate = moment(this.collection.selectedDate).add(delta, "weeks");
    var lastDate = moment(this.collection.getLastDay().date);
    var firstDate = moment(this.collection.getFirstDay().date);

    // ensure selected day is not earlier than the first day, or later than the last day
    newDate = moment.max(newDate, firstDate);
    newDate = moment.min(newDate, lastDate);

    this.selectDate(newDate.format(this.collection.dateFormat));
    this.repositionDays();

    const diff = newDate.diff(this.baseTrackingDate);
    const relativeDate = moment.duration(diff).asDays();

    try {
      const priceRange = this.priceRangeData(this.collection.selectedDate);
      this.options.track.priceRange(
        "auto_select",
        priceRange.minPrice,
        priceRange.maxPrice,
        priceRange.minPriceSlotsAmount,
        priceRange.slotsAmount,
        priceRange.hasDiscount,
        relativeDate
      );
    } catch (e) {}
    this.options.track.autoselect(relativeDate);
  },

  getDayElement (momentDate) {
    const $element = this.ui.dayList.find(
      `.js-day[data-date="${momentDate.format(this.collection.dateFormat)}"]`
    );
    // Some days can be missing in the response if there is no availability
    // so here a day is added to the initial date and we check again if it
    // exists in the DOM. Repeat until a valid day is found
    if (!$element.length) {
      momentDate.add(1, "days");
      return this.getDayElement(momentDate);
    }
    return $element;
  },

  repositionDays () {
    // update month label
    this.renderMonth();
    // reposition days
    const firstDayOfWeekDate = moment(this.collection.selectedDate).startOf(
      "week"
    );

    let firstDayOfWeekNode = this.getDayElement(firstDayOfWeekDate);

    let listPosition = 0;

    if (firstDayOfWeekNode.length > 0) {
      listPosition = firstDayOfWeekNode.position().left * -1;
    }

    this.ui.dayList.animate(
      {
        left: listPosition > 0 ? 0 : listPosition
      },
      300,
      "swing"
    );

    this.toggleWeekArrows();
  },

  dispatchNextPaginateEvent () {
    events.trigger(events.CHECKOUT_AVAILABILITY_PAGINATE, {
      firstIncludedDate: this.options.firstIncludedDate,
      lastIncludedDate: this.options.lastIncludedDate,
      direction: "next"
    });
  },

  dispatchPreviousPaginateEvent () {
    events.trigger(events.CHECKOUT_AVAILABILITY_PAGINATE, {
      firstIncludedDate: this.options.firstIncludedDate,
      lastIncludedDate: this.options.lastIncludedDate,
      direction: "previous"
    });
  },

  onPaginate ({ status, direction }) {
    if (status === "pending" && direction === "next") {
      this.pagination.isNextRequestPending = true;
    }
    if (/fulfilled|rejected/.test(status) && direction === "next") {
      this.pagination.isNextRequestPending = false;
    }
    if (status === "pending" && direction === "previous") {
      this.pagination.isPreviousRequestPending = true;
    }
    if (/fulfilled|rejected/.test(status) && direction === "previous") {
      this.pagination.isPreviousRequestPending = false;
    }
    if (status === "rejected") {
      this.toggleWeekArrows();
    }
  },

  showPreviousArrow () {
    if (
      this.pagination.isNextRequestPending ||
      this.pagination.isPreviousRequestPending
    ) {
      return false;
    }

    if (
      this.isFirstWeekDisplayed() &&
      this.pagination.isAbleToPaginatiateBack &&
      this.options.moreDaysInThePast
    ) {
      return true;
    }

    // User is not on the first page but they still need to scroll backwards
    if (
      !this.isFirstWeekDisplayed() &&
      this.collection.selectedWeek > this.collection.initialWeek
    ) {
      return true;
    }

    return false;
  },

  showNextArrow () {
    if (
      this.pagination.isNextRequestPending ||
      this.pagination.isPreviousRequestPending
    ) {
      return false;
    }

    if (this.isLastWeekDisplayed() && this.options.moreDaysInTheFuture) {
      return true;
    }

    if (!this.isLastWeekDisplayed()) {
      return true;
    }

    return false;
  },

  isLastWeekDisplayed () {
    return this.collection.selectedWeek === this.collection.maxWeeks;
  },

  isFirstWeekDisplayed () {
    return this.collection.selectedWeek === this.collection.initialWeek;
  },

  toggleWeekArrows () {
    // toggle previous week arrow
    this.ui.prev.toggle(this.showPreviousArrow());
    // toggle next week arrow
    this.ui.next.toggle(this.showNextArrow());
  },

  destroy () {
    this.stopListening(
      events,
      events.CHECKOUT_AVAILABILITY_EMPLOYEE_SELECTED,
      this.onEmployeeChanged
    );
    this.undelegateEvents();

    this.ui.dayList.empty();
  }
});

module.exports = WeekdaySelectionView;
